import { A11yModule } from '@angular/cdk/a11y';
import { Component, computed, input, output } from '@angular/core';

import { CamDatePipe } from '@camelot/utils';

import { Communication, CommunicationParticipantExtended, CommunicationType } from '../../services/dto/communication';
import { MessageContainerComponent } from '../message-container/message-container.component';

@Component({
  selector: 'cam-message-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [A11yModule, CamDatePipe, MessageContainerComponent],
})
export class ListComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  list = input.required<Communication[]>();

  limit = input<number | -1>(-1);

  taskId = input.required<string>();

  readonly = input(false);

  enableReply = input(true);

  askReply = output<{ communication: Communication; isForward: boolean }>();

  readonly CommunicationType = CommunicationType;

  readonly limitlist = computed(() => {
    const list = this.list();
    if (this.limit() === -1) {
      return list;
    }
    return list.slice(list.length - 1 - this.limit(), list.length - 1);
  });

  readonly groupedMessages = computed(() =>
    this.limitlist().reduce<{ date: string; messages: Communication[] }[]>((groups, communication) => {
      const date = new Date(communication.createdTime).toDateString();
      const existingGroup = groups.find(group => group.date === date);

      if (existingGroup) {
        existingGroup.messages.push(communication);
      } else {
        groups.push({ date, messages: [communication] });
      }
      return groups;
    }, [])
  );
}
